import { useTranslation } from 'react-i18next'

import { z } from '@/lib/zod'

export function EditCredentialsSchema() {
  return z.object({
    clientKey: z.string().min(1),
    currentPassword: z.string().min(1),
  })
}

export function ChangePasswordSchema() {
  const { t } = useTranslation('sso')

  return z
    .object({
      currentPassword: z.string().min(1),
      newPassword: z.string().min(1),
      confirmNewPassword: z.string().min(1),
    })
    .refine((data) => data.newPassword === data.confirmNewPassword, {
      message: t(
        'applications.drawer_manage_auth.edit_credentials.schema.password_mismatch',
      ),
      path: ['confirmNewPassword'],
    })
    .refine((data) => data.currentPassword !== data.newPassword, {
      message: t(
        'applications.drawer_manage_auth.edit_credentials.schema.password_cannot_be_the_same',
      ),
      path: ['newPassword'],
    })
}

export type EditCredentialsForm = z.infer<
  ReturnType<typeof EditCredentialsSchema>
>

export type ChangePasswordForm = z.infer<
  ReturnType<typeof ChangePasswordSchema>
>
